import { Box, Typography, useMediaQuery } from "@mui/material";

interface RepresentProps {
  mainText: string;
  mainTitle: string;
  steps: {
    imageUrl: string;
    text: string;
    title: string;
  }[];
}

function Steps({ mainText, mainTitle, steps }: RepresentProps) {
  const titleFormatSmall = useMediaQuery("(max-width: 400px)");

  return (
    <Box
      sx={(theme) => ({
        display: "flex",
        justifyContent: "center",
        padding: "20px 96px",
        [theme.breakpoints.down(1024)]: {
          padding: "1rem 6rem",
        },
        [theme.breakpoints.down(640)]: {
          padding: "1rem 3rem",
        },
        [theme.breakpoints.down(400)]: {
          padding: "1rem 2rem",
        },
        [theme.breakpoints.down(280)]: {
          padding: "1rem",
        },
      })}
    >
      <Box
        sx={{
          alignItems: "center",
          display: "flex",
          flexDirection: "column",
          maxWidth: "1100px",
          textAlign: "center",
          width: "100%",
        }}
      >
        <Typography
          sx={{
            marginBottom: "2rem",
            textAlign: "center",
          }}
          variant={titleFormatSmall ? "h2" : "h1"}
        >
          {mainTitle}
        </Typography>
        <Typography
          sx={{
            fontSize: "18px",
            marginBottom: "3rem",
            maxWidth: "500px",
            textAlign: "center",
          }}
        >
          {mainText}
        </Typography>
        <Box
          sx={(theme) => ({
            display: "flex",
            flexDirection: "column",
            gap: "40px",
            textAlign: "left",
            [theme.breakpoints.down(1280)]: {
              textAlign: "center",
            },
          })}
        >
          {steps.map((step) => (
            <Box
              key={step.title}
              sx={(theme) => ({
                "&:nth-of-type(even)": {
                  [theme.breakpoints.up(1200)]: {
                    flexDirection: "row-reverse",
                  },
                },
                alignItems: "center",
                display: "flex",
                gap: "40px",
                [theme.breakpoints.down(1280)]: {
                  flexDirection: "column",
                },
              })}
            >
              <Box
                alt="step illustration"
                component="img"
                src={step.imageUrl}
                sx={(theme) => ({
                  flex: "0 0 auto",
                  height: "auto",
                  maxWidth: "30rem",
                  width: "100%",
                  [theme.breakpoints.down(1280)]: {
                    maxWidth: "15rem",
                  },
                })}
              />
              <Box
                sx={{
                  display: "flex",
                  flex: "1",
                  flexDirection: "column",
                  justifyContent: "center",
                  maxWidth: "500px",
                }}
              >
                <Box
                  sx={(theme) => ({
                    alignItems: "center",
                    display: "initial",
                    flexDirection: "row",
                    left: "inherit",
                    paddingBlock: "30px",
                    position: "relative",
                    textAlign: "inherit",
                    [theme.breakpoints.down(768)]: {
                      alignItems: "flex-start",
                      flexDirection: "column",
                      left: "inherit",
                    },
                  })}
                >
                  <Typography
                    sx={{ fontSize: "18px" }}
                    variant={titleFormatSmall ? "h4" : "h2"}
                  >
                    {step.title}
                  </Typography>
                </Box>
                <Typography sx={{ fontSize: "18px" }}>{step.text}</Typography>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
}

export default Steps;
